import axios, { AxiosError } from 'axios';
import Client from './client';
import { User } from '@/filemenu/admin/user';

export function isAxiosError(error: unknown): error is AxiosError {
  return (error as AxiosError).isAxiosError !== undefined;
}

export function isClient(value: unknown): value is Client {
  return (value as Client).serverURL !== undefined;
}

export async function login(
  serverURL: string, username: string, password: string,
): Promise<Client | string> {
  try {
    const { data } = await axios.post(`${serverURL}/auth`, { username, password }, { withCredentials: true });
    const client = await Client.Create(serverURL);
    client.user = data;
    return client;
  } catch (error) {
    if (isAxiosError(error)) {
      return 'Invalid username or password';
    }

    if (error instanceof Error) {
      return error.message;
    }

    console.error(error);
    return 'Unexpected error occured. Check console for details';
  }
}

export { Client };
